
import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectReportsStore = (state) => state.reports;

const makeSelectReportsList = () => createSelector(
  selectReportsStore,
  (reportsState) => reportsState.reports,
);

const makeSelectQuickFilteredParams = () => createSelector(
  selectReportsStore,
  (reportsState) => reportsState.filterParams,
);

const makeSelectUsedReport = () => createSelector(
  selectReportsStore,
  (reportsState) => reportsState.usedReport,
);

const makeSelectRequestStatus = () => createSelector(
  selectReportsStore,
  (reportsState) => reportsState.requestPending,
);

const makeSelectIgnorePrompt = () => createSelector(
  selectReportsStore,
  (reportsState) => reportsState.ignorePrompt,
);

const makeSelectUsedReportStatus = () => createSelector(
  selectReportsStore,
  (reportsState) => reportsState.usedReportStatus,
);

const makeSelectAvailableReports = () => createSelector(
  selectReportsStore,
  (reportsState) => reportsState.availableReports,
);

const makeSelectRenderColumn = () => createSelector(
  selectReportsStore,
  (reportState) => reportState.renderFields,
);

const makeSelectFilterProps = () => createSelector(
  selectReportsStore,
  (reportState) => reportState.filterProps,
);

const makeSelectOriginParams = () => createSelector(
  selectReportsStore,
  (reportState) => reportState.originReportParam,
);

export {
  selectReportsStore,
  makeSelectUsedReport,
  makeSelectReportsList,
  makeSelectFilterProps,
  makeSelectIgnorePrompt,
  makeSelectRenderColumn,
  makeSelectOriginParams,
  makeSelectRequestStatus,
  makeSelectUsedReportStatus,
  makeSelectAvailableReports,
  makeSelectQuickFilteredParams,
};
